/* ============================================================
   IN SOLISIA — theme JS
   Vanilla, no build step. Handles:
   - Header transparent → solid on scroll
   - Cart drawer open/close
   - PDP accordion
   - Notes index category filter
   - SHOPIFY AJAX CART (add, remove, refresh drawer, update header count)
   - PDP variant picker → form input + price/availability updates
   ============================================================ */

(function () {
  'use strict';

  /* ----- HEADER scroll behavior ----- */
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var transparent = header.classList.contains('is-transparent');
    var threshold = 20;
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (transparent) {
        if (y > threshold) {
          header.classList.remove('is-transparent');
          header.classList.add('is-scrolled');
        } else {
          header.classList.add('is-transparent');
          header.classList.remove('is-scrolled');
        }
      } else {
        header.classList.toggle('is-scrolled', y > threshold);
      }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ----- CART DRAWER open/close ----- */
  function initCartDrawer() {
    var drawer   = document.querySelector('.cart-drawer');
    var backdrop = document.querySelector('.cart-drawer-backdrop');
    if (!drawer) return;

    function open() {
      drawer.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Event delegation so dynamically-added triggers (drawer items) work too.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); }
    });
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    window.__inCart = { open: open, close: close };
  }

  /* ----- ACCORDION (PDP details) ----- */
  function initAccordion() {
    document.querySelectorAll('[data-accordion]').forEach(function (item) {
      var head = item.querySelector('[data-accordion-head]');
      if (!head) return;
      head.addEventListener('click', function () {
        item.classList.toggle('is-open');
      });
    });
  }

  /* ----- NOTES FILTER (Notes index page) ----- */
  function initNotesFilter() {
    var buttons = document.querySelectorAll('.notes-filters__item[data-filter]');
    if (!buttons.length) return;
    var cards = document.querySelectorAll('[data-category]');
    function applyFilter(filter) {
      cards.forEach(function (card) {
        if (filter === 'all' || card.getAttribute('data-category') === filter) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    }
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        applyFilter(btn.getAttribute('data-filter'));
      });
    });
  }

  /* ============================================================
     SHOPIFY AJAX CART
     /cart/add.js     POST → add an item
     /cart.js         GET  → fetch current cart state
     /cart/change.js  POST → change line quantity (used to remove)
     ============================================================ */

  function formatMoney(cents) {
    // Safe USD default; Shopify formats properly server-side on checkout.
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderDrawerItem(item) {
    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="100" loading="lazy">'
      : '<div class="img-placeholder aspect-4-5">[ product ]</div>';

    var meta = '';
    if (item.variant_title && item.variant_title.indexOf('Default') < 0) {
      meta = escapeHtml(item.variant_title) + ' · ';
    }
    meta += 'Qty ' + item.quantity;

    return [
      '<article class="cart-item" data-cart-line="' + item.key + '">',
      '  <a href="' + item.url + '" class="cart-item__image">' + imgHtml + '</a>',
      '  <div class="cart-item__details">',
      '    <div class="cart-item__top">',
      '      <a href="' + item.url + '" class="cart-item__name" style="text-decoration:none; color:inherit;">',
              escapeHtml(item.product_title),
      '      </a>',
      '      <button type="button" class="cart-item__remove" data-cart-remove="' + item.key + '" aria-label="Remove">×</button>',
      '    </div>',
      '    <div class="cart-item__meta">' + meta + '</div>',
      '    <div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>',
      '  </div>',
      '</article>'
    ].join('\n');
  }

  function renderDrawerEmpty() {
    var msg = (window.__inCartEmptyText || 'Your bag is empty.');
    var href = (window.__inCartCollectionUrl || '/collections/all');
    return [
      '<div class="cart-drawer__empty" data-cart-empty>',
      '  <p class="cart-drawer__empty-text">' + escapeHtml(msg) + '</p>',
      '  <a href="' + href + '" class="link-cta">View the collection →</a>',
      '</div>'
    ].join('\n');
  }

  function updateDrawer(cart) {
    var body = document.querySelector('[data-cart-body]');
    var footer = document.querySelector('[data-cart-footer]');
    if (!body || !footer) return;

    if (cart.item_count === 0) {
      body.innerHTML = renderDrawerEmpty();
      footer.hidden = true;
    } else {
      body.innerHTML = '<div class="cart-drawer__items" data-cart-items>'
        + cart.items.map(renderDrawerItem).join('\n')
        + '</div>';
      footer.hidden = false;
    }

    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = '(' + cart.item_count + ')';
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateDrawer(cart); return cart; });
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: formData
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    })
    .then(function () { return refreshCart(); });
  }

  function removeLine(key) {
    var fd = new FormData();
    fd.append('id', key);
    fd.append('quantity', 0);
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: fd
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateDrawer(cart); return cart; });
  }

  function initCartActions() {
    // Add-to-bag from any product form
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form.product-form');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      addToCart(new FormData(form))
        .then(function () { if (window.__inCart) window.__inCart.open(); })
        .catch(function (err) {
          alert((err && err.description) || 'Could not add to bag. Please try again.');
        })
        .finally(function () { if (btn) btn.disabled = false; });
    });

    // Remove cart line
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-remove]');
      if (!btn) return;
      e.preventDefault();
      removeLine(btn.getAttribute('data-cart-remove'));
    });
  }

  /* ----- PDP VARIANT PICKER -----
     Size buttons carry data-variant-id; clicking updates the form's hidden
     id input and toggles price/availability state. */
  function initVariantPicker() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var input = picker.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var addBtn  = document.querySelector('[data-add-to-bag]');
      var buttons = picker.querySelectorAll('[data-variant-id]');

      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          buttons.forEach(function (x) { x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          if (input) input.value = b.getAttribute('data-variant-id');
          var price = b.getAttribute('data-variant-price');
          if (price && priceEl) priceEl.textContent = price;
          var available = b.getAttribute('data-variant-available') === 'true';
          if (addBtn) {
            addBtn.disabled = !available;
            addBtn.textContent = available
              ? (addBtn.getAttribute('data-label-default') || 'Add to bag')
              : 'Sold out';
          }
        });
      });
    });
  }

  /* ----- BOOT ----- */
  document.addEventListener('DOMContentLoaded', function () {
    initHeaderScroll();
    initCartDrawer();
    initAccordion();
    initNotesFilter();
    initCartActions();
    initVariantPicker();
  });
})();
